import {
  IAssessmentOutputs,
  IAssessmentInputs
} from "../store/main.interfaces";
import {
  calculateAverageHandlingTimeReduction,
  calculateBandwidthFreed,
  calculateBenefitSuitability,
  calculateEaseOfImplementation,
  calculateEffortToImplement,
  calculateErrorReduction,
  calculateFullTimeEquivalentNeededToPerform,
  calculateOverallStability
} from "../store/assessment.calc";

export function assembleAssessmentOutputs(
  inputs: IAssessmentInputs
): IAssessmentOutputs {
  const assessmentOutputs: IAssessmentOutputs = {
    easeOfImplementation: calculatedEaseOfImplementation(inputs),
    benefitSuitability: calculatedBenefitSuitability(inputs),
    bandwidthFreed: calculatedBandWidthFreed(inputs),
    errorReduction: calculatedErrorReduction(inputs),
    averageHandlingTimeReduction: calculatedAverageHandlingTime(inputs),
    effortToImplement: calculatedEffortToImplement(inputs),
    calculationTimestamp: Date.now()
  };
  return assessmentOutputs;
}
function calculatedOverallStability(inputs: IAssessmentInputs) {
  return calculateOverallStability(
    inputs.inputDataStructure,
    inputs.processStability,
    inputs.applicationStability
  );
}
function calculatedEaseOfImplementation(inputs: IAssessmentInputs) {
  return calculateEaseOfImplementation(
    calculatedOverallStability(inputs),
    inputs.applicationsUsed,
    inputs.processSteps,
    inputs.decisionDifficulty,
    inputs.amountOfStructuredInputData,
    inputs.remoteDesktopApplication,
    inputs.inputScanned
  );
}
function calculatedBenefitSuitability(inputs: IAssessmentInputs) {
  return calculateBenefitSuitability(
    inputs.digitalInputPercentage,
    inputs.unfinishedProcessPercentage,
    inputs.amountOfStructuredInputData,
    inputs.decisionDifficulty
  );
}
function calculatedBandWidthFreed(inputs: IAssessmentInputs) {
  return calculateBandwidthFreed(
    calculatedBenefitSuitability(inputs),
    calculateFullTimeEquivalentNeededToPerform(
      inputs.processFrequency,
      inputs.frequencyVolume,
      inputs.averageRuntime
    )
  );
}
function calculatedErrorReduction(inputs: IAssessmentInputs) {
  return calculateErrorReduction(
    inputs.humanErrorPercentage,
    inputs.digitalInputPercentage,
    inputs.unfinishedProcessPercentage,
    inputs.inputScanned,
    inputs.decisionDifficulty
  );
}
function calculatedAverageHandlingTime(inputs: IAssessmentInputs) {
  return calculateAverageHandlingTimeReduction(
    calculatedBenefitSuitability(inputs)
  );
}
function calculatedEffortToImplement(inputs: IAssessmentInputs) {
  return calculateEffortToImplement(calculatedEaseOfImplementation(inputs));
}
